export const removeElementFromArray = (array, elementToRemove) => {
    let indexOfEl = array.indexOf(elementToRemove);
    if (indexOfEl !== -1) {
        return [
            ...array.slice(0, indexOfEl),
            ...array.slice(++indexOfEl)
        ];
    }
    return array;
}